import { useEffect, useState } from 'react';
import FusionCharts from 'fusioncharts';
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ReactFC from 'react-fusioncharts';
import { useSelector } from 'react-redux';
import moment from 'moment';
import _isEmpty from 'lodash/isEmpty';
import { Row, Col } from 'reactstrap';

import { useActions } from 'utils/hooks';
import * as integrationsActions from 'store/integrations/actions';

import DateInput, { mode } from 'common/components/form/inputs/date';

ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

const Overview = () => {
  const [dates, setDates] = useState({
    from: moment().subtract(1, 'month'),
    to: moment()
  });

  const [getLogReportsGraph] = useActions([integrationsActions.getLogReportsGraph]);
  let graphs = useSelector(state => state.integrations.graphs);
  const loading = useSelector(state => state.integrations.loading);

  const renderDataSource = graphLabel => {
    const chart = {
      yaxisname: 'Calls/day',
      numdivlines: '3',
      showvalues: '0',
      legenditemfontsize: '14',
      legenditemfontbold: '1',
      plottooltext: '<b>$dataValue</b> calls/day $seriesName on $label',
      theme: 'fusion',
      labelDisplay: 'WRAP'
    };

    const graph = graphs[graphLabel];

    return {
      chart,
      ...graph
    };
  };

  const chartConfigs = graph => {
    return {
      type: 'msspline',
      width: '100%',
      dataFormat: 'json',
      dataSource: renderDataSource(graph)
    };
  };

  useEffect(() => {
    if (dates.from && dates.to) {
      getLogReportsGraph({
        integration: 'searoutes',
        date: {
          from: moment(dates.from).format('YYYY-MM-DD'),
          to: moment(dates.to).format('YYYY-MM-DD')
        },
        label: 'Sea_Routes'
      });

      getLogReportsGraph({
        integration: 'bunker_ex_bunkering',
        date: {
          from: moment(dates.from).format('YYYY-MM-DD'),
          to: moment(dates.to).format('YYYY-MM-DD')
        },
        label: 'BunkerEx'
      });

      getLogReportsGraph({
        integration: 'fixer_currency',
        date: {
          from: moment(dates.from).format('YYYY-MM-DD'),
          to: moment(dates.to).format('YYYY-MM-DD')
        },
        label: 'Fixer_Currency'
      });
    }
  }, [dates.from, dates.to]);

  if (!_isEmpty(graphs)) {
    graphs = {
      Sea_Routes: {
        id: 1,
        ...graphs.Sea_Routes
      },
      BunkerEx: {
        id: 2,
        ...graphs.BunkerEx
      },
      Fixer_Currency: {
        id: 3,
        ...graphs.Fixer_Currency
      }
    };
  }

  return (
    <>
      <div className="w-100p justify-content-end d-flex align-items-center">
        <DateInput
          onChange={newDates => {
            setDates({
              from: newDates.from ? moment(newDates.from) : dates.from,
              to: newDates.to ? moment(newDates.to) : dates.to
            });
          }}
          activeMode={mode.range.date}
          useStringValue
          {...dates}
        />
      </div>
      <Row>
        {loading
          ? null
          : Object.keys(graphs)
              .sort((a, b) => a.id > b.id)
              .map((graph, index) => (
                <Col xs={4} key={index}>
                  <div className={`log-reports-graphs`}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="log-reports-graphs__label-indicator">
                        {graph.replace('_', ' ')}
                      </div>
                    </div>
                    <div className="">
                      <ReactFC {...chartConfigs(graph)} />
                    </div>
                  </div>
                </Col>
              ))}
      </Row>
    </>
  );
};

export default Overview;
